import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex,
    Label,
    Select,
    ActionMenu,
    formatSelectOption
} from '@ubisend/pulse-components';
import { ConverseComposerButton } from '@ubisend/pulse-volt';
import { ComposerSelect } from '@ubisend/pulse-composer';

const AgentComposerSelectMenu = ({ composerQuery, composer, setComposer, disabled }) => {
    const getComposerValue = () => {
        if (!composerQuery.isSuccess) {
            return null;
        }

        if (!composer) {
            return formatSelectOption(
                composerQuery.data.data.find(c => !c.is_custom && c.type === 'live-chat')
            );
        }

        return formatSelectOption(
            composerQuery.data.data.find(({ id }) => id === composer)
        );
    };

    return (
        <ActionMenu
            position={ActionMenu.POSITIONS.TOP}
            Button={props => (
                <ConverseComposerButton {...props}>
                    <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                            className="secondary"
                            d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
                        />
                    </svg>
                </ConverseComposerButton>
            )}
            buttonProps={{
                'aria-label': 'Toggle composer actions',
                title: 'Toggle composer actions'
            }}
        >
            <Flex col pad style={{ width: '13rem' }}>
                <Flex col>
                    <Label htmlFor="composer">Composer</Label>
                    <Select
                        id="composer"
                        menuPlacement="top"
                        options={
                            composerQuery.isSuccess
                                ? ComposerSelect.groupComposerSelectOptions(
                                    composerQuery.data.data,
                                    formatSelectOption
                                )
                                : []
                        }
                        isLoading={composerQuery.isLoading}
                        isDisabled={disabled}
                        value={getComposerValue()}
                        onChange={option => setComposer(option.value)}
                    />
                </Flex>
            </Flex>
        </ActionMenu>
    );
};

AgentComposerSelectMenu.propTypes = {
    composerQuery: PropTypes.object.isRequired,
    composer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    setComposer: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default AgentComposerSelectMenu;